<template>
  <div>
    <div class="banner withoutImg">
      <div class="container">
        <div class="caption">
          <p><h1>订阅</h1></p>
          <p>感谢您关注 Jasper Morris Inside Burgundy</p>
        </div>
      </div>
    </div>

    <!-- 注册 -->
    <div class="container" style="margin-bottom:20px">
      <section class="innerPage myaccount">
        <div class="container">
          <div class="breadcrumbWrap">
            <div class="breadcrumb">
              <span property="itemListElement" typeof="ListItem">
                <a
                  property="item"
                  typeof="WebPage"
                  title="Go to Jasper Morris Inside Burgundy."
                  href="#/"
                  class="home"
                >
                  <span property="name">首页</span>
                </a>
                <meta property="position" content="1">
              </span> /
              <span property="itemListElement" typeof="ListItem">
                <span property="name">订阅</span>
                <meta property="position" content="2">
              </span>
            </div>
          </div>
        </div>
        <!-- 注册 -->

        <div class="container" v-if="this.$store.state.isLogin&&!isPay">
          <p
            style="font-size: 30px; color: rgb(0, 0, 0); font-weight: 800;font-family: '宋体', serif;"
          >欢迎订阅网站内容</p>
          <p style="padding-top: 20px">✔ 通过订阅您将获得所有的品鉴报告及过往酒评</p>
          <p>✔ 您可通过网页、微信小程序、App（开发中）全平台查看酒评，方便快捷</p>
          <p>✔ 做为订阅用户，您将获赠Inside Burgundy的定制版Riedel勃艮第酒杯一支</p>
          <p>✔ 订阅费用为800元/年</p>
          
           <div style="border-top:2px solid #ccc">
      <p style="color: rgb(51, 51, 51); padding-top: 20px;  font-size: 20px; font-weight: 700;">赠品收货信息</p>
      <p style="color: rgb(51, 51, 51); font-size: 15px;">Inside Burgundy的定制版Riedel勃艮第酒杯一支</p>
      <ul style="line-height: 50px;margin:0">
       <li class="wppb-form-field wppb-default-last-name" id="wppb-form-element-50" style="display: flex;align-items: center;">
            <label for="xingname">收货人
               <span class="wppb-required" title="This field is required">*</span>
            </label>
            <input
              class="text-input default_field_lastname"
              name="xingname"
              maxlength="70"
              v-model="xingname"
              type="text"
              id="xingname"
              style="width: 400px;
    margin-left: 26px;"
            >
          </li>
           <li class="wppb-form-field wppb-default-e-mail" id="wppb-form-element-51" style="display: flex;align-items: center;">
            <label for="telephone">
              联系电话
               <span class="wppb-required" title="This field is required">*</span>
            </label>
            <input
              class="text-input default_field_email"
              name="telephone"
              maxlength="70"
              type="email"
              v-model="telephone"
              id="telephone"
              required
              style="width: 400px;
    margin-left: 10px;"
            >
          </li>
          <li class="wppb-form-field wppb-default-e-mail" id="wppb-form-element-53" style="display: flex;align-items: center;">
            <label for="profile">
              收货地址
               <span class="wppb-required" title="This field is required">*</span>
            </label>
            <input
              class="text-input default_field_email"
              name="profile"
              maxlength="70"
              type="text"
              v-model="profile"
              id="profile"
              required
              style="width: 400px;
    margin-left: 10px;"
            >
          </li>
      </ul>
    </div>
    <div style="padding-top: 20px">
            <button
              @click="payloading"
              style="background:#970635;padding:5px 50px;border:0;color:#fff;font-size:16px"
            >订阅</button>
          </div>
        </div>

        <!--<div class="container">-->
        <!--<div style="width:100%;text-align: left;">-->
        <!--<p></p>-->
        <!--<div class="whySubscribe above_register no_image no_button">-->
        <!--<div class="whySubscribeText animate fadeInUp triggeredCSS3">-->
        <!--<h1>会员特权</h1>-->
        <!--<ul>-->
        <!--<li>免费查看全部品鉴报告</li>-->
        <!--<li>主题晚宴报名资格</li>-->
        <!--<li>在线Master Class课程报名资格</li>-->
        <!--<li>一年订阅费用800元起</li>-->
        <!--</ul>-->
        <!--</div>-->
        <!--</div>-->
        <!--<p></p>-->
        <!--</div>-->
        <!--</div>-->
      </section>

      <registerBox
        v-if="!this.$store.state.isLogin"
        goHome="#/Subscribe?_t=isLogin"
        boxStyle
        submitButton="订阅"
      />
    </div>

    <!-- 二维码 -->
    <div class="container" v-if="isPay">
      <div class="dindan">
        <div class="dindanlei">
          <p>订单编号：{{payData.orderNo}}</p>
          <p>订单类型：{{payData.productName}}</p>
        </div>
        <div style="float:right">
          <span style="padding-right: 20px;">应付金额：{{payData.price}}元</span>
        </div>
      </div>

      <div
        style="padding-top:20px;width: 65%; display: flex;margin:0 auto;
  flex-flow:  row nowrap;
  justify-content: space-between;"
      >
        <div style="width: 230px;display: flex">
          <img src="../assets/greenlogo.png" alt style="width:50px;height:45px">
          <span style="line-height: 44px;padding-left:20px">微信支付</span>
        </div>
        <div style="float:right">
          <div style="padding-right: 20px;line-height:48px">
            支付：
            <span style="color:red">{{payData.price}}</span>元
          </div>
        </div>
      </div>

      <div style="width: 230px; padding-top: 20px;margin:0 auto;">
        <img :src="payData.qrCode">
        <img src="../assets/shuomingwenzi.png" alt>
      </div>
    </div>
    <!-- 二维码 -->
  </div>
</template>
<script>
import registerBox from "../template/registertemp";
import ajax from "../ajax";
export default {
  data() {
    return {
      isPay: false,
      payData: {},
      xingname:"",
      telephone:"",
      profile:"",
    };
  },
  components: {
    registerBox
  },
  watch: {
    $route(value) {
      if (value.query._t) this.payloading();
    }
  },
  methods: {
    payloading() {
      this.isPay = true;
      // ajax.postWebpay({
        
      // }).then(res=>{
      // console.log(res.data)
      // })
      ajax.getPay({
        userAddress: this.profile,
        userEmail:'',
        userId: this.$store.state.userdata.userId,
        userName: this.xingname,
        userTel: this.telephone
      }).then(res => {
        console.log(res.data)
        this.payData = res.data;
      });
    },
    successPay() {
      alert("支付成功！");
      this.$router.push("/home");
    },
    hreftwo() {
      this.$router.push({ path: "./insideburgundy" });
    },

    changeActive($event) {
      $event.currentTarget.style = "border-bottom: 4px solid #990033;";
    },
    removeActive($event) {
      $event.currentTarget.style = "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Subscribe.vue